module.exports = __webpack_public_path__ + "static/media/doc_browser_gray.5b10901c.svg";